import { CheckmarkOutlined, DangerOutlined } from '@icon';
import React from 'react';
import { useTheme } from 'styled-components';

interface FormFeedbackProps {
  status?: 'success' | 'error';
}

const FormFeedback: React.FunctionComponent<FormFeedbackProps> = ({ status }) => {
  const theme = useTheme();

  if (!status) {
    return null;
  }

  return status === 'success' ? (
    <CheckmarkOutlined color={theme.color.solid.success} width={16} height={16} />
  ) : (
    <DangerOutlined color={theme.color.solid.error} width={16} height={16} />
  );
};

export default React.memo(FormFeedback);
